import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { SERVICES } from "@/lib/constants";

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.06 } },
};
const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } },
};

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader eyebrow="What We Do" title="Premium Services Engineered for Growth" desc="Full-stack digital marketing — strategy, creatives, ads and automation built for Indian businesses." />

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6"
        >
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={s.title}
                variants={item}
                data-testid={`service-card-${i}`}
                className="group relative rounded-2xl p-6 glass glass-hover transition-all duration-300"
              >
                <div className="w-11 h-11 rounded-xl grid place-items-center bg-[#D4AF37]/10 border border-[#D4AF37]/30 text-[#D4AF37] mb-4 group-hover:bg-[#D4AF37]/20 transition-colors">
                  <Icon size={20} />
                </div>
                <h3 className="text-white font-semibold text-lg tracking-tight">{s.title}</h3>
                <p className="text-white/60 text-sm mt-2 leading-relaxed">{s.desc}</p>
                <div className="mt-4 flex items-center gap-1 text-[11px] uppercase tracking-[0.2em] text-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity">
                  Learn more <Icons.ArrowUpRight size={12} />
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export const SectionHeader = ({ eyebrow, title, desc, center = false }) => (
  <div className={`mb-14 max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
    <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] font-semibold mb-3">{eyebrow}</div>
    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tighter text-white leading-tight">{title}</h2>
    {desc && <p className="mt-4 text-white/60 text-base sm:text-lg leading-relaxed">{desc}</p>}
  </div>
);
